import { ListOption } from './types';

export function filterListOptionsWithParentsAndChildren(
  options: ListOption[],
  searchString: string,
): ListOption[] {
  const result: ListOption[] = [];
  const addedValues = new Set<string>();

  // Helper function to add an item's parents
  const addParents = (index: number) => {
    const parentsStack = []; // Use a stack to keep track of parents to maintain order
    let currentIndent = options[index].indent ?? 0;
    for (let i = index - 1; i >= 0; i--) {
      // Start looking for parents above the current index
      const indent = options[i].indent ?? 0;
      if (indent < currentIndent) {
        if (!addedValues.has(options[i].value)) {
          parentsStack.push(options[i]);
          addedValues.add(options[i].value);
        }
        currentIndent = indent; // Update currentIndent to find the next parent up
      }
    }
    // Add parents in the correct order (from top to bottom)
    while (parentsStack.length) {
      result.push(parentsStack.pop() as ListOption);
    }
  };

  // Helper function to add all children of a matched item
  const addChildren = (index: number) => {
    const parentIndent = options[index].indent ?? 0;
    for (let i = index + 1; i < options.length; i++) {
      if ((options[i].indent ?? 0) > parentIndent) {
        if (!addedValues.has(options[i].value)) {
          result.push(options[i]); // Add children in their original order
          addedValues.add(options[i].value);
        }
      } else {
        break; // Stop if we've reached an item at the same level or higher than the parent
      }
    }
  };

  for (let i = 0; i < options.length; i++) {
    if (
      options[i].label.toLowerCase().includes(searchString.toLowerCase()) &&
      !addedValues.has(options[i].value)
    ) {
      addParents(i); // Add parents of the matched item
      result.push(options[i]); // Add the matched item itself
      addedValues.add(options[i].value);
      addChildren(i); // Add all children of the matched item
    }
  }

  return result;
}
